import { requestApi } from '../util/network'

// 获取用户预存款记录
export const getPredepositList =
(type,params) =>
  requestApi(
    '/Memberfund/predepositlog',
    'POST',
    {
		type:type,
        page:params.page,
        per_page:params.per_page
    },
    'member'
  )
// 获取贡献值记录
export const getExppointsList =
(type,params) =>
  requestApi(
    '/Memberfund/exppointslog',
    'POST',
    {
		type:type,
        page:params.page,
        per_page:params.per_page
    },
    'member'
  )  
// 获取用户充值卡记录
export const getRechargeCardList =
    (params) =>
        requestApi(
            '/Memberfund/rcblog',
            'POST',
            {
                page:params.page,
                per_page:params.per_page
            },
            'member'
        )
// 增加充值卡
export const addRechargeCard =
    (rc_sn) =>
        requestApi(
            '/Memberfund/rechargecard_add',
            'POST',
            {
                rc_sn:rc_sn
            },
            'member'
        )
// 通证解锁
export const addRechargeLock =
    (id, password) =>
        requestApi(
            '/Memberfund/lock_add',
            'POST',
            {
				id:id,
				password:password
            },
            'member'
        )
// 通证解锁
export const saleToken =
    (num, password) =>
        requestApi(
            '/Memberfund/saleToken',
            'POST',
            {
				num:num,
				password:password
            },
            'member'
        )
